export default "<h1>Ooops</h1>\n<p>Die pagina bestaat niet. <a routerLink=\"/\">Klik hier om naar de hoofdpagina te gaan.</a></p>\n<p>\n    &nbsp;\n</p>"